











import * as _ from 'lodash';
import {Vue, Component} from 'vue-property-decorator';
import imageViewer from './image-viewer/image-viewer.vue';
import sliderEditor from './slider-editor/slider-editor.vue';

@Component({
  components: {
    imageViewer,
    sliderEditor,
  },
})
export default class ImageEditor extends Vue {
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/image-filter/image-editor/image-editor.vue